// extracted by mini-css-extract-plugin
export default {"title":"sL3BqYlyE0+NY79kydjekQ==","list":"DKCalVjFJJiWjlWoQ7A1hA==","list-item":"Ud+Fud0oGDTfBvjsAS5qiA==","image":"JgC3bgp5cy-J5uMiEinFyQ=="};